import { Toolbar as StyledToolbar } from 'styles/toolbar'
import * as css from './styles'
import { PaginationButtons } from '../PaginationButtons'
import { Filters } from '../filters'

export const Toolbar = () => {
  return (
    <StyledToolbar style={{ justifyContent: 'space-between' }}>
      <css.FiltersContainer>
        <Filters />
      </css.FiltersContainer>
      <css.PaginationButtonsContainer>
        <PaginationButtons />
      </css.PaginationButtonsContainer>
    </StyledToolbar>
  )
}
